module.exports = __webpack_public_path__ + "img/banner_itemone_downimg.53b62598.png";